import get from 'lodash/get.js';
import PendoIcon from '../icon/pendo-icon.vue.js';
import PendoLoadingIndicator from '../loading-indicator/pendo-loading-indicator.vue.js';
import { PendoAnalytics } from '../../directives/analytics/pendo-analytics.js';
import { iconTypeToGeneric } from '../../utils/utils.js';

const THEME_CLASSES_MAP = {
  'p2-dark': 'p2-dark',
  'p2-light': 'app',
  'app': 'app'
};
var script = {
  name: 'PendoButton',
  components: {
    PendoIcon,
    PendoLoadingIndicator
  },
  directives: {
    PendoAnalytics
  },
  inject: {
    $form: {
      default: ''
    }
  },
  props: {
    type: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'secondary', 'tertiary', 'link', 'danger'].includes(value)
    },
    theme: {
      type: String,
      default: 'app',
      validator: theme => ['app', 'p2-dark'].includes(theme)
    },
    size: {
      type: String,
      default: 'medium',
      validator: size => ['mini', 'small', 'medium'].includes(size)
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    prefixIcon: {
      type: String,
      default: ''
    },
    suffixIcon: {
      type: String,
      default: ''
    },
    iconSize: {
      type: [String, Number],
      default: '14'
    },
    block: {
      type: Boolean,
      default: false
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClass() {
      return ['pendo-button', `pendo-button--${this.type}`, `pendo-button--${this.size}`, `${THEME_CLASSES_MAP[this.theme]}`, {
        'is-disabled': this.buttonDisabled,
        'is-loading': this.loading,
        'is-block': this.block,
        'is-icon-only': this.isIconOnly,
        'has-prefix-icon': !this.isIconOnly && this.showPrefixIcon,
        'has-suffix-icon': this.showSuffixIcon
      }];
    },
    buttonDisabled() {
      const isParentFormDisabled = get(this.$form, 'disabled');
      return this.loading || this.disabled || isParentFormDisabled;
    },
    isIconOnly() {
      return !this.$slots.default && !this.label && !!this.icon;
    },
    showSuffixIcon() {
      if (this.loading) {
        return false;
      }
      return Boolean(this.suffixIcon);
    },
    showPrefixIcon() {
      if (this.loading) {
        return false;
      }
      return Boolean(this.icon || this.prefixIcon);
    },
    ariaLabel() {
      if (this.$attrs && this.$attrs['aria-label']) {
        return this.$attrs['aria-label'];
      }
      if (this.icon) {
        return iconTypeToGeneric(this.icon);
      }
      return null;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-button.vue2.js.map
